import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'api/ApiClient';

import { QueryKeys } from './common';

type UseGetPropertiesParams = {
  enabled?: boolean;
};

export function useGetProperties(params: UseGetPropertiesParams = { enabled: true }) {
  const { enabled } = params;

  return useQuery({ queryKey: [QueryKeys.GetProperties], queryFn: () => apiClient.getProperties(), enabled });
}
